import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import type { DeadlineDelayRequestFormInterface } from '@zaoblako/shared/modules/project/dto/deadline-delay-request/deadline-delay-request-form.dto';
import { ProjectService } from '@zaoblako/web/core/services/project/project.service';
import { DatepickerComponent } from '@zaoblako/web/shared/dumbs/datepicker/datepicker.component';
import { EditorComponent } from '@zaoblako/web/shared/dumbs/editor/editor.component';
import { ButtonModule } from 'primeng/button';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { ProjectStoreService } from '../../components/project/card/services/project-store.service';

@Component({
  standalone: true,
  selector: 'crm-project-change-deadline-form-overlay-panel',
  templateUrl: './project-change-deadline-form-overlay-panel.component.html',
  imports: [CommonModule, DatepickerComponent, OverlayPanelModule, EditorComponent, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectChangeDeadlineFormOverlayPanelComponent {
  @ViewChild('opDeadline') public opDeadline: OverlayPanel;
  public loading = false;

  @Input() public form = <DeadlineDelayRequestFormInterface>{};
  @Output() public formChange = new EventEmitter<DeadlineDelayRequestFormInterface>();

  public constructor(
    private readonly projectService: ProjectService,
    private readonly projectStoreService: ProjectStoreService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public sendNewDeadline() {
    this.loading = true;
    this.cdRef.markForCheck();

    this.projectService.sendChangeDeadline(this.projectStoreService.getProject?.id, this.form).subscribe({
      next: (resInfoDeadline) => {
        const project = { ...this.projectStoreService.getProject };
        project.deadlineDelayRequest = resInfoDeadline;
        this.projectStoreService.setState({ project });
        this.formChange.emit(this.form);
        this.form = <DeadlineDelayRequestFormInterface>{};
        this.loading = false;
        this.cdRef.markForCheck();
        this.opDeadline.hide();
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
